import { render, staticRenderFns } from "./MarketStatus.vue?vue&type=template&id=4ccac82c&"
import script from "./MarketStatus.vue?vue&type=script&lang=js&"
export * from "./MarketStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports